// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0_supports-color@6.1.0_/node_modules/css-loader/dist/cjs.js??ref--7-oneOf-3-1!../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??ref--7-oneOf-3-2!./font.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/.pnpm/vue-style-loader@4.1.2/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("70a53cb2", content, false, {"sourceMap":false,"shadowMode":false});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0_supports-color@6.1.0_/node_modules/css-loader/dist/cjs.js??ref--7-oneOf-3-1!../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??ref--7-oneOf-3-2!./font.css", function() {
     var newContent = require("!!../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0_supports-color@6.1.0_/node_modules/css-loader/dist/cjs.js??ref--7-oneOf-3-1!../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??ref--7-oneOf-3-2!./font.css");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}